import React from "react"

import { FeedbackActionsOverlay } from "./FeedbackActionsOverlay"
import { useFeedbackActionsOverlayModel } from "./hooks/useFeedbackActionsOverlayModel"

export const FeedbackActionsOverlayConnector = React.memo(() => (
  <FeedbackActionsOverlay {...useFeedbackActionsOverlayModel()} />
))

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    FEEDBACK_ACTIONS_OVERLAY: null
  }
}
